module.exports = "/_next/static/images/OgImage-72bccd290817834f3d2137c2e1be3576.png";